import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export interface UserProfile {
  userId: string;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string | null;
  department?: string | null;
  avatarUrl?: string | null;
  themeMode: string;
  roles: string[];
}

export interface UserProfileUpdateRequest {
  firstName: string;
  lastName: string;
  phoneNumber?: string | null;
  department?: string | null;
  themeMode?: string;
  newPassword?: string;
}

export interface UserAvatarResponse {
  avatarUrl: string;
}

export interface UserPreferencesResponse {
  themeMode: string;
}

async function request<T>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || response.statusText);
  }

  return (await response.json()) as T;
}

export function getUserProfile(): Promise<UserProfile> {
  return request<UserProfile>("/api/users/me");
}

export function updateUserProfile(
  payload: UserProfileUpdateRequest,
): Promise<UserProfile> {
  return request<UserProfile>("/api/users/me", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
}

export function uploadAvatar(
  file: File,
): Promise<UserAvatarResponse> {
  const formData = new FormData();
  formData.append("avatar", file, file.name || "avatar");

  return request<UserAvatarResponse>("/api/users/me/avatar", {
    method: "POST",
    body: formData,
  });
}

export function removeAvatar(): Promise<UserAvatarResponse> {
  return request<UserAvatarResponse>("/api/users/me/avatar", {
    method: "DELETE",
  });
}

export function updateThemeMode(
  themeMode: string,
): Promise<UserPreferencesResponse> {
  return request<UserPreferencesResponse>("/api/users/me/preferences", {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ themeMode }),
  });
}
